import Menu from './Compartido/Menu.jsx';
import TextoNoticia from './FichaNoticia/TextoNoticia.jsx';
import Footer from './Compartido/Footer.jsx';

const FichaNoticia = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextoNoticia
                noticia={props.lanoticia}
                populares={props.populares}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default FichaNoticia;
